module.exports = __webpack_public_path__ + "img/host_img.14269103.png";